import { Component, inject, Input, OnInit } from '@angular/core';
import { DeleteConfirmationOptions } from '@app/@core/enums';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';

export const DefaultDeleteDialogConfig = {
  height: 'quarter',
  showCloseButton: false,
  padding: '16px',
  backgroundColor: 'transparent',
  data: {
    text: '',
    deleteText: 'Delete',
    showReportButton: false,
  },
};

@Component({
  selector: 'app-m-delete-dialog',
  templateUrl: './m-delete-confirmation-dialog.component.html',
  styleUrls: ['./m-delete-confirmation-dialog.component.scss'],
  standalone: false,
})
export class MDeleteConfirmationDialogComponent implements OnInit {
  @Input() text = '';
  @Input() deleteText = 'Delete';
  @Input() showReportButton = false;
  DeleteConfirmationOptions = DeleteConfirmationOptions;
  bottomSheetData: any = {};
  private readonly _bottomSheetService = inject(NgxBottomSheetService);

  ngOnInit() {
    const configData = this._bottomSheetService.currentSheetData;
    // const configDataByAnotherMethod = this.bottomSheetData;
    if (configData) {
      this.text = configData.text;
      this.deleteText = configData.deleteText || 'Delete';
      this.showReportButton = configData.showReportButton;
    }
  }

  onClose(option: DeleteConfirmationOptions) {
    this._bottomSheetService.close(option);
  }
}
